import { Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import {
    ConvocatedStatus,
    getConvocatedStatusLabel
} from '../../pages/Periodicos/consts/convocatedTypes';
import { EstadoExpuestoEnum } from '../../pages/Periodicos/consts/periodicosTypes';

interface StateBadgeConvocatedProps {
    state: ConvocatedStatus | number;
    text?: string;
    hideIcon?: boolean;
}

const StateBadgeConvocated = ({ state, text, hideIcon }: StateBadgeConvocatedProps) => {
    let icon = null;
    let stateText = text || getConvocatedStatusLabel(state);
    let bgColor = '';
    let textColor = '';

    switch (state) {
        case EstadoExpuestoEnum.CONVOCADO:
            icon = <InfoIcon sx={{ color: '#105014' }} fontSize="small" />;
            bgColor = '#E1EBE3';
            textColor = '#105014';
            break;
        case ConvocatedStatus.CONVOCATORIA_GENERADA:
            icon = <InfoIcon sx={{ color: '#E0E9F3' }} fontSize="small" />;
            bgColor = '#E0E9F3';
            textColor = '#0B357C';
            break;

        case EstadoExpuestoEnum.TURNO_ASIGNADO:
            icon = <CheckCircleIcon sx={{ color: '#6619D2' }} fontSize="small" />;
            bgColor = '#E7E0F0';
            textColor = '#6619D2';
            break;
        case ConvocatedStatus.PENDIENTE_CAMBIOS:
            icon = <CheckCircleIcon sx={{ color: '#D3940D' }} fontSize="small" />;
            bgColor = '#F9F3E6';
            textColor = '#D3940D';
            break;

        case EstadoExpuestoEnum.CON_RESULTADO:
            icon = <PendingIcon sx={{ color: '#169355' }} fontSize="small" />;
            bgColor = '#EAFBED';
            textColor = '#169355';
            break;
        case ConvocatedStatus.RESULTADOS_GENERADOS:
            icon = <PendingIcon sx={{ color: '#105014' }} fontSize="small" />;
            bgColor = '#E2EEE3';
            textColor = '#105014';
            break;

        default:
            bgColor = '#fff';
            textColor = '#000';
            break;
    }

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: bgColor,
                padding: '4px 8px',
                borderRadius: '16px',
                fontWeight: 'bold',
                color: textColor
            }}
        >
            {!hideIcon && icon}
            <span style={{ marginLeft: hideIcon ? 0 : '4px' }}>{stateText}</span>
        </Box>
    );
};
export default StateBadgeConvocated;
